import styled from "styled-components";

export const DashboardTemplate = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
`;

export const DashboardDividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.colors.primary10};
`;

export const DashboardShipOperationLayout = styled.div`
  display: flex;
  flex-direction: row;
  gap: 26px;
`;

export const DashboardShipOperationDividerLine = styled.div`
  width: 1px;
  height: 12px;
  background: #00000019;
`;

export const DashboardShipOperationBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const DashboardShipOperationText = styled.p`
  font-size: 1.2rem;
  color: #00000099;
`;

export const DashboardShipOperationCheckBox = styled.div`
  width: 14px;
  height: 14px;
  border: 1px solid #00000049;
  border-radius: 2px;
  background: none;
`;
